module.exports = __webpack_public_path__ + "img/teacher.2a2305d2.png";